/* AF - product page buy card (2026 redesign). Small glue around Dawn:
   - Add to cart shows "Added ✓" for 1.6s after a successful add from this
     page's form (the cart drawer still opens, as before)
   - "N in cart" under the price follows the cart (drawer edits included)
   - the offers bar (Store Credit mode off) or the Store Credit line (mode on)
     follows size, quantity and cart
   Dawn still does the real work: product-info.js swaps the price box on a
   size change, product-form.js adds to cart. Markup: sections/main-product.liquid.
   Below the buy card (markup: snippets/af-pdp-description.liquid):
   - Common Questions: one answer open at a time, "Read all (N)" / "Show fewer"
   - the full-description panel's Add to cart (desktop): size chips that
     mirror the size tiles, and a button that closes the panel and presses
     the real Add to cart */
(() => {
  const card = document.querySelector('[data-af-buy]');
  if (!card || card.dataset.afPdpReady) return;
  card.dataset.afPdpReady = '1';

  const sid = card.dataset.sectionId;
  const form = () => document.getElementById(`product-form-${sid}`);
  const submit = () => document.getElementById(`ProductSubmitButton-${sid}`);
  const qtyInput = () => document.getElementById(`Quantity-${sid}`);
  const variantId = () => {
    const f = form();
    const i = f && f.querySelector('input[name="id"]');
    return i ? Number(i.value) : 0;
  };
  // id -> { p: price in cents, a: available }
  let prices = {};
  try {
    const el = card.querySelector('[data-af-pdp-prices]');
    prices = el ? JSON.parse(el.textContent) : {};
  } catch (e) { prices = {}; }

  const qty = () => {
    const n = parseInt((qtyInput() || {}).value || '1', 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  /* ---------- offers bar (mode off) / Store Credit earn line (mode on) ---------- */
  const offersWrap = card.querySelector('[data-af-pdp-offers]');
  // variant id -> quantity in the cart: seeded from the page (Liquid) so the first render agrees with it,
  // then kept by the same cart fetch as "N in cart". Parsed lazily: the core script may load after this one.
  let inCart = null;
  const inCartMap = () => {
    if (inCart) return inCart;
    inCart = window.AFCashback ? window.AFCashback.parseInCart(offersWrap && offersWrap.dataset.inCart) : {};
    return inCart;
  };
  let cartSubtotal = offersWrap ? Number(offersWrap.dataset.cartSubtotal) || 0 : 0;
  // another discount (not Store Credit) in the cart: the earn line says so. undefined until the live cart answers: the page's seed holds.
  let cartDiscounted;
  // Store Credit mode on: snippets/af-cashback-earn.liquid sits here; off / shadow: the wrapper is empty
  const earnLine = offersWrap ? offersWrap.querySelector('[data-af-cb-earn]') : null;
  // Store Credit mode off: the offers bar (snippets/af-offers.liquid, redrawn by assets/af-offers.js)
  const offersBar = offersWrap ? offersWrap.querySelector('.af-offers') : null;
  // id: the variant from Dawn's variantChange event, which fires before the form's id input is updated
  function syncOffers(id) {
    const vid = Number(id) || variantId();
    const ev = prices[vid];
    if (offersBar && window.AFOffers) {
      const line = ev && ev.a ? ev.p * qty() : 0;
      window.AFOffers.render(offersBar, cartSubtotal + line);
    }
    if (!earnLine || !window.AFCashback) return;
    window.AFCashback.renderEarn(earnLine, window.AFCashback.earnTotal(cartSubtotal, ev && ev.a ? ev.p : 0, qty(), inCartMap()[vid] || 0), !(ev && ev.a), cartDiscounted);
  }

  /* ---------- in cart ---------- */
  function paintInCart(count) {
    const box = document.getElementById(`price-${sid}`);
    const wrap = box && box.querySelector('[data-af-incart]');
    if (!wrap) return;
    const n = wrap.querySelector('[data-af-incart-n]');
    if (n) n.textContent = String(count);
    wrap.hidden = count < 1;
  }
  let cartSeq = 0;
  function refreshCart() {
    const seq = ++cartSeq;
    return fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (!cart || seq !== cartSeq) return; // a newer refresh is on its way
        cartSubtotal = Number(cart.items_subtotal_price) || 0;
        if (window.AFCashback) cartDiscounted = window.AFCashback.hasOtherDiscount(cart);
        inCart = {};
        (cart.items || []).forEach((it) => { inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity; });
        const count = inCart[variantId()] || 0; // the map the cart just gave us
        paintInCart(count);
        syncOffers();
      })
      .catch(() => {});
  }

  /* ---------- "Added ✓" ---------- */
  // Only an add from this page's own form counts (quick add in the rails
  // below publishes the same event). A failed add never publishes, so it
  // never shows "Added".
  let pendingAt = 0;
  let addedTimer = 0;
  document.addEventListener('submit', (e) => {
    if (e.target === form()) pendingAt = Date.now();
  }, true);
  function showAdded() {
    const b = submit();
    if (!b) return;
    b.classList.add('is-added');
    clearTimeout(addedTimer);
    addedTimer = setTimeout(() => b.classList.remove('is-added'), 1600);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === 'product-form' && pendingAt && Date.now() - pendingAt < 15000) {
        pendingAt = 0;
        showAdded();
      }
      refreshCart();
    });
    // the price box (with its in-cart count) was just re-rendered for the new size
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event && event.data && event.data.sectionId && event.data.sectionId !== sid) return;
      const vid = event && event.data && event.data.variant && event.data.variant.id;
      requestAnimationFrame(() => syncOffers(vid));
    });
  }
  // quantity: Dawn's +/- buttons fire `change` on the input too
  document.addEventListener('change', (e) => {
    if (e.target && e.target.id === `Quantity-${sid}`) syncOffers();
  });

  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });

  // The Store Credit core (layout/theme.liquid) and af-offers.js are deferred
  // and may run after this file; deferred scripts all run before DOMContentLoaded.
  // Only one of the two is on the page (mode on: earn line; off: offers bar).
  if (earnLine || offersBar) {
    if (earnLine ? window.AFCashback : window.AFOffers) syncOffers();
    else document.addEventListener('DOMContentLoaded', syncOffers, { once: true });
  }
})();

/* ---------- Common Questions ---------- */
(() => {
  const setOpen = (item, open) => {
    item.classList.toggle('is-open', open);
    const q = item.querySelector('.af-pfaq__q');
    if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;

    const q = t.closest('.af-pfaq__q');
    if (q) {
      const item = q.closest('.af-pfaq__item');
      const root = q.closest('[data-af-pfaq]');
      if (!item || !root) return;
      const opening = !item.classList.contains('is-open');
      // one open at a time
      if (opening) root.querySelectorAll('.af-pfaq__item.is-open').forEach((o) => { if (o !== item) setOpen(o, false); });
      setOpen(item, opening);
      return;
    }

    const all = t.closest('[data-af-pfaq-all]');
    if (all) {
      const root = all.closest('[data-af-pfaq]');
      if (!root) return;
      const showing = all.getAttribute('aria-expanded') !== 'true';
      const extras = root.querySelectorAll('[data-af-pfaq-extra]');
      extras.forEach((x) => {
        if (!showing) setOpen(x, false);
        x.hidden = !showing;
      });
      all.setAttribute('aria-expanded', showing ? 'true' : 'false');
      const label = all.querySelector('[data-af-pfaq-all-label]');
      if (label) label.textContent = showing ? all.dataset.less : all.dataset.more;
      // move to the first new question, so keyboard and screen reader users land on it
      if (showing && extras[0]) {
        const fq = extras[0].querySelector('.af-pfaq__q');
        if (fq) fq.focus({ preventScroll: true });
      }
    }
  });
})();

/* ---------- full-description panel: Add to cart (desktop) ---------- */
(() => {
  const box = document.querySelector('[data-af-desc-buy]');
  const card = document.querySelector('[data-af-buy]');
  if (!box || !card) return;
  const sid = card.dataset.sectionId;
  const submit = () => document.getElementById(`ProductSubmitButton-${sid}`);
  if (!submit()) return; // no Add to cart on the page, so none in the panel
  const panel = box.closest('dialog');
  const sizes = box.querySelector('[data-af-desc-buy-sizes]');
  const priceOut = box.querySelector('[data-af-desc-buy-price]');
  const mlOut = box.querySelector('[data-af-desc-buy-ml]');
  const atc = box.querySelector('[data-af-desc-buy-atc]');
  const atcLabel = box.querySelector('[data-af-desc-buy-label]');
  const fmt = (cents) => '৳' + Math.round(cents / 100).toLocaleString('en-US');

  let prices = {};
  try {
    const el = card.querySelector('[data-af-pdp-prices]');
    prices = el ? JSON.parse(el.textContent) : {};
  } catch (e) { prices = {}; }
  const variantId = () => {
    const f = document.getElementById(`product-form-${sid}`);
    const i = f && f.querySelector('input[name="id"]');
    return i ? Number(i.value) : 0;
  };
  const tiles = () => [...card.querySelectorAll('.af-ds__item')];
  const text = (el, sel) => { const x = el.querySelector(sel); return x ? x.textContent.trim() : ''; };

  // one chip per size tile; a chip click clicks its tile, so the normal
  // size flow runs (price box, URL, stock, sticky bar)
  function buildChips() {
    sizes.textContent = '';
    tiles().forEach((tile, i) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'af-desc-buy__chip';
      chip.setAttribute('role', 'radio');
      chip.dataset.i = String(i);
      const ml = document.createElement('span');
      ml.className = 'af-desc-buy__chip-ml';
      ml.textContent = text(tile, '.af-ds__label');
      chip.appendChild(ml);
      const subText = text(tile, '.af-ds__sub');
      if (subText) {
        const sub = document.createElement('span');
        sub.className = 'af-desc-buy__chip-sub';
        sub.textContent = subText;
        chip.appendChild(sub);
      }
      sizes.appendChild(chip);
    });
  }

  function sync() {
    const list = tiles();
    let label = '';
    [...sizes.children].forEach((chip) => {
      const tile = list[Number(chip.dataset.i)];
      const on = !!tile && tile.getAttribute('aria-checked') === 'true';
      chip.setAttribute('aria-checked', on ? 'true' : 'false');
      chip.tabIndex = on ? 0 : -1;
      chip.classList.toggle('is-off', !!tile && tile.classList.contains('is-soldout'));
      if (on) label = text(tile, '.af-ds__label');
    });
    const v = prices[variantId()];
    if (priceOut) priceOut.textContent = v ? fmt(v.p) : '';
    if (mlOut) mlOut.textContent = label;
    const b = submit();
    const off = !b || b.disabled;
    atc.disabled = off;
    if (atcLabel) atcLabel.textContent = off ? 'Sold out' : 'Add to cart';
  }

  sizes.addEventListener('click', (e) => {
    const chip = e.target.closest('.af-desc-buy__chip');
    if (!chip) return;
    const tile = tiles()[Number(chip.dataset.i)];
    if (tile) tile.click();
    requestAnimationFrame(sync); // the ring moves at once; price follows the fetch
  });
  sizes.addEventListener('keydown', (e) => {
    const chips = [...sizes.children];
    const i = chips.indexOf(e.target.closest('.af-desc-buy__chip'));
    if (i < 0) return;
    let j = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % chips.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + chips.length) % chips.length;
    else if (e.key === 'Home') j = 0;
    else if (e.key === 'End') j = chips.length - 1;
    if (j < 0) return;
    e.preventDefault();
    chips[j].focus();
    chips[j].click();
  });

  // Close the panel first (an open modal makes the cart drawer inert), then
  // press the real Add to cart, which adds and opens the drawer as usual.
  atc.addEventListener('click', () => {
    if (atc.disabled) return;
    const go = () => { const b = submit(); if (b && !b.disabled) b.click(); };
    if (panel && panel.open && window.AFSheet) {
      panel.addEventListener('af-sheet:closed', go, { once: true });
      window.AFSheet.close(panel);
    } else {
      go();
    }
  });

  if (panel) panel.addEventListener('af-sheet:opened', sync);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event && event.data && event.data.sectionId && event.data.sectionId !== sid) return;
      requestAnimationFrame(sync);
    });
  }

  buildChips();
  box.hidden = false;
  sync();
})();

/* ---------- fully sold out: "In stock now" alternatives (Oct 2026) ----------
   A sold-out page used to end at the grey button; similar products sat about
   4.5 screens down. Up to 4 in-stock picks from Shopify's own related
   recommendations go right under the button. Fetched after load, so the
   photo still paints first; stays hidden if nothing in stock comes back. */
(() => {
  const box = document.querySelector('[data-af-alts]');
  if (!box) return;
  const list = box.querySelector('[data-af-alts-list]');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const fmt = (cents) => Math.round(cents / 100).toLocaleString('en-US');
  const img = (src, w) => (src ? `${src.startsWith('//') ? 'https:' + src : src}${src.includes('?') ? '&' : '?'}width=${w}` : '');

  const load = () => {
    fetch(`${root}recommendations/products.json?product_id=${box.dataset.productId}&limit=10&intent=related`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const items = ((data && data.products) || []).filter((p) => p.available).slice(0, 4);
        if (!items.length) return;
        items.forEach((p) => {
          const li = document.createElement('li');
          li.className = 'af-alts__item';
          const a = document.createElement('a');
          a.className = 'af-alts__link';
          a.href = p.url;
          const src = p.featured_image || (p.images && p.images[0]) || '';
          if (src) {
            const im = document.createElement('img');
            im.className = 'af-alts__img';
            im.src = img(src, 160);
            im.srcset = `${img(src, 120)} 120w, ${img(src, 160)} 160w, ${img(src, 240)} 240w`;
            im.sizes = '56px';
            im.width = 160;
            im.height = 160;
            im.alt = '';
            im.loading = 'lazy';
            im.decoding = 'async';
            a.appendChild(im);
          }
          const text = document.createElement('span');
          text.className = 'af-alts__text';
          const t = document.createElement('span');
          t.className = 'af-alts__title';
          t.textContent = p.title;
          const pr = document.createElement('span');
          pr.className = 'af-alts__price';
          const tk = document.createElement('span');
          tk.className = 'af-tk';
          tk.textContent = '৳';
          pr.append(p.price_varies ? 'From ' : '', tk, fmt(p.price_min != null ? p.price_min : p.price));
          text.append(t, pr);
          a.appendChild(text);
          li.appendChild(a);
          list.appendChild(li);
        });
        box.hidden = false;
      })
      .catch(() => {});
  };
  if (document.readyState === 'complete') load();
  else window.addEventListener('load', load, { once: true });
})();
